import NotFound from '~/components/404';

const InitialPage = () => {
  return <NotFound hasTryAgainButton={false} />;
};

export default InitialPage;
